import { createFileRoute } from '@tanstack/react-router';

import { ClientsPage } from '@/clients/pages';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/clients/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: ClientsRoute
});

function ClientsRoute() {
  return (
    <ClientsPage />
  );
}
